import { log } from "../../../lib/Logger";
import { getCenterCoordinates } from '../../../lib/GeneralUtils';

// ------------------------------------
// Constants
// ------------------------------------
export const INIT = 'INIT';

export const TOGGLE_SQUARE = 'TOGGLE_SQUARE';
export const DESELECT_SQUARE = 'DESELECT_SQUARE';

export const SET_BOARD_SIZE = 'SET_BOARD_SIZE';
export const RELOAD_SQUARES = 'RELOAD_SQUARES';

export const CENTER_CELL_TEXT = 'Attend TMP Bootcamp';

// ------------------------------------
// Actions
// ------------------------------------
export const toggleSquare = (x, y) => {
    return {
        type: TOGGLE_SQUARE,
        x,
        y
    };
};

export const init = (wordList = [], cellWords = [], selectedCells = [], hasSentNotification = false, xSize = DEFAULT_SIZE_X, ySize = DEFAULT_SIZE_Y) => {
    return {
        type: INIT,
        wordList,
        cellWords,
        selectedCells,
        hasSentNotification,
        xSize,
        ySize,
    };
};

// ------------------------------------
// Thunks
// ------------------------------------

// ------------------------------------
// Reducer
// ------------------------------------
const DEFAULT_SIZE_X = 5;
const DEFAULT_SIZE_Y = 5;

const initialState = {
    // rows [columns]
    selectedCells: [],
    cellWords: [],
    boardSize: {
        x: DEFAULT_SIZE_X,
        y: DEFAULT_SIZE_Y,
    },
    wordPool: [],
    hasSentNotification: false,
};
export default function boardReducer(state = initialState, action) {
    switch (action.type) {
        case INIT:
            let x = action.xSize;
            let y = action.ySize;
            let oldCellWords = action.cellWords;
            return {
                ...state,
                wordPool: action.wordList,
                hasSentNotification: action.hasSentNotification,
                boardSize : {x, y},
                selectedCells: clearSelectedCells(x, y, action.selectedCells),
                cellWords: oldCellWords.length > 0 ? oldCellWords : distributeWords(x, y, action.wordList),
            };
        case TOGGLE_SQUARE:
            let existingValue = state.selectedCells[action.y][action.x];
            return {
                ...state,
                selectedCells: immutableUpdateObjectInArray(state.selectedCells, action.y,
                    immutableUpdateObjectInArray(state.selectedCells[action.y], action.x, !existingValue)),
            };
        default:
            return state;
    }
}

function clearSelectedCells(xCells, yCells, storedSelectedCells) {
    let cells = [...Array(yCells)].map((_, y) => {
        return [...Array(xCells)].map((_, x) => {
            return Boolean(storedSelectedCells.hasOwnProperty(y) &&
                storedSelectedCells[y].hasOwnProperty(x) &&
                storedSelectedCells[y][x]) || false;
        });
    });
    let [centerX, centerY] = getCenterCoordinates(xCells, yCells);
    cells[centerY][centerX] = true;
    return cells;
}

function distributeWords(xCells, yCells, wordPool, randomly = true) {
    let [centerX, centerY] = getCenterCoordinates(xCells, yCells);
    let words = wordPool.slice(0);
    return [...Array(yCells)].map((_, y) => {
        return [...Array(xCells)].map((_, x) => {
            if (x === centerX && y === centerY) {
                return CENTER_CELL_TEXT;
            }
            let wordIndex = Math.round(Math.random() * (words.length - 1));
            return words.splice(wordIndex, 1);
        });
    });
}

function immutableUpdateObjectInArray(array, index, newValue) {
    return array.map((value, i) => {
        if(i !== index) {
            // This isn't the droid we are looking for
            return value;
        }

        // Otherwise, this is the one we want - return an updated value
        return newValue;
    });
}



// WEBPACK FOOTER //
// ./src/routes/Board/modules/board.js